// null version → stable id-only key: render surfaces recompile fresh and never
// boot the builder app, so keying on version there is both impossible and wrong.
export function feedRowRenderKey(dynamicComponentId, version) {
  return version === null || version === undefined
    ? `dc-${dynamicComponentId}`
    : `dc-${dynamicComponentId}-v${version}`;
}
